import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { ReportesService } from '../../../services/reportes.service';
import { Helper } from '../../../helpers/helper';
import { RutasService } from '../../../services/rutas.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CurrencyPipe, DatePipe, LowerCasePipe } from '@angular/common';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { RegionesService } from '../../../services/regiones.service';
import { ExcelService } from '../../../services/excel.service';
import { ExcelColumns, ExcelRows, ExcelTitle } from '../../../interfaces/excel.interface';

const ID_PAGINA = 27;

@Component({
  selector: 'app-retabilidad-ruta',
  templateUrl: './retabilidad-ruta.component.html',
  styleUrls: ['./retabilidad-ruta.component.css']
})
export class RetabilidadRutaComponent implements OnInit {
  @ViewChild('pdf') pdf: ElementRef;
  rutasSeleccionadas = [];
  rutasSeleccionadasAntes = false;
  list = [];
  page = 1;
  limit = '50';
  offset = 0;
  loaded = false;
  exportando = false;
  pdfORexcel = 1;
  loading = false;
  size = 0;
  rutas = [];
  regiones = [];
  subregiones = [];
  regionSeleccionada = [];
  subRegionSeleccionada = [];
  now = new Date(this.helper.getDate());
  resOneWeek  = new Date().setTime(this.now.getTime() - (6 * 24 * 60 * 60 * 1000));
  oneWeek = new Date( this.resOneWeek);
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  private model: any = {
    endDate: {
      year: this.now.getFullYear(),
      month: this.now.getMonth() + 1,
      day: this.now.getDate()
    },
    beginDate: {
      year: this.oneWeek.getFullYear(),
      month: this.oneWeek.getMonth() + 1,
      day: this.oneWeek.getDate()
    }
  };
  configPdf = {
    direccion: '',
    tel: ''
  };
  rentabilidad = {
    capital_cobrado: 0,
    gastos_cierre: 0,
    interes_cobrado: 0,
    moras_cobradas: 0,
    total_gastos: 0,
    perdida_incobrables: 0,
    cobrado_incobrables: 0
  };
  active: number;
  dropdownSettings: any;
  multiSelectRegiones: any;
  multiSelectSubRegiones: any;

  constructor(
    private reporteService: ReportesService,
    private helper: Helper, private rutaService: RutasService,
    private empleadoService: EmpleadosServicio,
    private route: ActivatedRoute,
    private router: Router,
    private render: Renderer,
    private regionesService: RegionesService,
    private excelService: ExcelService

  ) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3
      && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    this.fecha_desde = this.model.beginDate;
    this.fecha_hasta = this.model.endDate;
    this.initRutas();
    this.initRegiones();
    this.initConfigPdf();
    /*if ( localStorage.getItem('rutasSeleccionadas')) {
      this.rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }*/
    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    if (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }
  }

  ngOnInit() {
    this.verificarQueryString();
    this.initConfigMultiSelect();
  }

  private initConfigMultiSelect() {
    let badgeShowLimit = 1;
    if (window.matchMedia('(min-width: 992px)').matches) {
      badgeShowLimit = 5;
    } else if (window.matchMedia('(max-width: 992px)').matches) {
      badgeShowLimit = 3;
    } else {
      badgeShowLimit = 8;
    }

    this.dropdownSettings = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit,
      searchPlaceholderText: 'Búsqueda'
    };

    this.multiSelectRegiones = {
      singleSelection: false,
      text: 'Seleccionar Region',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 4,
      searchPlaceholderText: 'Búsqueda'
    };

    this.multiSelectSubRegiones = {
      singleSelection: false,
      text: 'Seleccionar Sub-Region',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 4,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  private initRegiones(): void {
    this.regionesService.regiones().subscribe(RESPONSE => {

      for (const region of RESPONSE) {
        this.regiones.push({
          id: region.ID_REGION,
          itemName: String(region.nombre)
        })
      }
    });
}

  initSubregiones(): void {
    this.subregiones = []
    this.regionesService.subRegiones(this.regionSeleccionada.map(data => data.id).join()).subscribe(RESPONSE => {
      console.log(this.regionSeleccionada)
      for (const region of RESPONSE) {
        this.subregiones.push({
          id: region.ID_SUBREGION,
          itemName: String(region.nombre)
        })
      }
    }); }

  private initReport(): void {
    const fechas = {
      fecha_inicia: '',
      fecha_termina: ''
    };

    if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
      fechas.fecha_inicia = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
      fechas.fecha_termina = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
    this.loading = true;
    this.reporteService.reporteRentabilidad(
      fechas, this.rutasSeleccionadas.map(data => data.id).join(),
      this.limit, this.offset,
      this.regionSeleccionada.map(data => data.id).join()
      ,this.subRegionSeleccionada.map(data => data.id).join()
    ).subscribe((res: any) => {
      this.active = parseFloat(localStorage.getItem('rentabilidad_ruta_active')) || -1;

      this.rentabilidad.capital_cobrado = res.capital_cobrado;
      this.rentabilidad.gastos_cierre = res.gastos_de_cierre;
      this.rentabilidad.interes_cobrado = res.interes_cobrado;
      this.rentabilidad.moras_cobradas = res.moras_cobradas;
      this.rentabilidad.total_gastos = res.total_gastos;
      this.rentabilidad.perdida_incobrables = res.perdida_incobrables;
      this.rentabilidad.cobrado_incobrables = res.cobrado_incobrables;
      //console.log(this.rentabilidad)
      this.list = res.data;
      this.size = res.total_items;
      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
    });
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas().subscribe(res => {
      for (const ruta of res.rutas) {
        this.rutas.push({
          id: ruta.ID_RUTA,
          itemName: String(ruta.nombre)
        });
      }
    });
  }

  filtrarReporte() {
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['region'] = this.regionSeleccionada;
    queryParams['subregion'] = this.subRegionSeleccionada;

    if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
      queryParams['fecha_inicia'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
      queryParams['fecha_termina'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      queryParams['rutas'] = rutas;
    }
    queryParams['limite'] = this.limit;

    const regions = this.regionSeleccionada.map(data => data.id).join()

    if (regions) {
      queryParams['region'] = regions;

      this.initSubregiones();
    }
    else {
      if(this.regionSeleccionada.length >= 1){
        this.initSubregiones()
      }
      else{
        this.subregiones = []
        this.subRegionSeleccionada = []
      }
      delete queryParams['region'];
    }
    const subRegion = this.subRegionSeleccionada.map(data => data.id).join()
    if(subRegion){
      queryParams['subregion'] = subRegion;
    }
    else{
      delete queryParams['subregion'];
    }

    this.router.navigate(['./reporte/rentabilidad-ruta'], { queryParams: queryParams });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {

        if (params.fecha_inicia || params.fecha_termina) {

          if (params.fecha_inicia) {
            const yearInit = parseFloat(params.fecha_inicia.split('-')[0]);
            const monthInit = parseFloat(params.fecha_inicia.split('-')[1]);
            const dayInit = parseFloat(params.fecha_inicia.split('-')[2]);

            if ( !isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit ) ) {
              this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
            }
          }

          if (params.fecha_termina) {
            const yearEnd = parseFloat(params.fecha_termina.split('-')[0]);
            const monthEnd = parseFloat(params.fecha_termina.split('-')[1]);
            const dayEnd = parseFloat(params.fecha_termina.split('-')[2]);

            if ( !isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd ) ) {
              this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
            }
          }
        }

      /*   if (params.region) {
          this.regionSeleccionada = params.region;
          this.initSubregiones();
        }
        if (params.subregion) {
          this.subRegionSeleccionada = params.subregion;
        } */

        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = parseFloat(this.limit) * (this.page - 1);
        }

        if (params.rutas) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }
        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }
        if (!isNaN(params.limite)) {
          this.limit = params.limite;
        }

        this.initReport();
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.offset = parseFloat(this.limit) * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./reporte/rentabilidad-ruta'], { queryParams: queryParams });
  }

  private initConfigPdf(): void {
    this.reporteService.obtenerConfiguraciones()
    .subscribe((res: any) => {
      this.configPdf.direccion = res.direccion_recibo;
      this.configPdf.tel = res.telefono_recibo;
    });
  }

  exportar(downOpen = true, conListaclientes = false) {
    if (!this.exportando && this.list.length > 0) {
      this.exportando = true;
      const title = `Rentabilidad de rutas`;
      const rows = [];
      const currencyPipe = new CurrencyPipe('en-US');
      const lowerCasePipe = new LowerCasePipe();
      const datePipe = new DatePipe('en-US');

      const columns = [
        {title: 'Cliente', dataKey: '0'},
        {title: 'Préstamo', dataKey: '1'},
        {title: 'Prestado', dataKey: '2'},
        {title: 'Último cobro', dataKey: '3'},
        {title: 'Cobros', dataKey: '4'},
        {title: 'Capital cobrado', dataKey: '5'},
        {title: 'Interes cobrado', dataKey: '6'},
        {title: 'Gasto cierre', dataKey: '7'},
        {title: 'Mora cobrada', dataKey: '8'},
        {title: 'Total cobrado', dataKey: '9'}
      ];

      const fechas = {
        fecha_inicia: '',
        fecha_termina: ''
      };

      if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
        fechas.fecha_inicia = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
      }

      if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
        fechas.fecha_termina = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
      }
      this.reporteService.reporteRentabilidad(fechas, this.rutasSeleccionadas.map(data => data.id).join(), '', '')
      .subscribe((res: any) => {
      // if (conListaclientes) {

        for (const row of res.data) {
          if(this.pdfORexcel==1) {
            rows.push({
              '0': this.helper.capitalizeFirstLetter( lowerCasePipe.transform(row.cliente) ),
              '1': row.ID_PRESTAMO,
              '2': currencyPipe.transform(row.capital, '', true, '1.0-0'),
              '3': datePipe.transform(row.ultimo_cobro, 'dd-MM-yyyy'),
              '4': row.cantidad_cobros,
              '5': currencyPipe.transform(row.capital_cobrado),
              '6': currencyPipe.transform(row.interes_cobrado),
              '7': currencyPipe.transform(row.gasto_cierre),
              '8': currencyPipe.transform(row.mora_cobrada),
              '9': currencyPipe.transform(row.total_cobrado)
            });
          } else {
            rows.push({
              '0': this.helper.capitalizeFirstLetter( lowerCasePipe.transform(row.cliente) ),
              '1': row.ID_PRESTAMO,
              '2': row.capital,
              '3': datePipe.transform(row.ultimo_cobro, 'dd-MM-yyyy'),
              '4': row.cantidad_cobros,
              '5': row.capital_cobrado,
              '6': row.interes_cobrado,
              '7': row.gasto_cierre,
              '8': row.mora_cobrada,
              '9': row.total_cobrado
            });
          }
        }
      // }

        const columnStyles = {
          id: {fillColor: 255, textColor: 0},
          0: {columnWidth: 100},
          1: {columnWidth: 50},
          2: {columnWidth: 60},
          3: {columnWidth: 80},
          4: {columnWidth: 40},
        };

        // tslint:disable-next-line:max-line-length

        if(this.pdfORexcel==1){
          this.helper.exportarRentabilidad(
            // this.configPdf, title, [], [], this.empleadoService.datosEmpleado.nombreCompleto,
            this.configPdf, title,conListaclientes ?  columns : [], conListaclientes ? rows : [], this.empleadoService.datosEmpleado.nombreCompleto,
            this.pdf, this.render, conListaclientes ?  columnStyles : [], downOpen)
          .then(() => {
            this.exportando = false;
          })
          .catch(() => {
            this.exportando = false;
          });
        } else {
          const titulo: ExcelTitle = {
            title: 'Reporte de Rentabilidad',
            font: { name: 'Arial', size: 16, underline: 'double', bold: true }
          };

          const columns: ExcelColumns =  {
            // tslint:disable-next-line:max-line-length
            columns: ['Cliente'.toUpperCase(),
                      'Préstamo'.toUpperCase(),
                      'Prestado'.toUpperCase(),
                      'Último cobro'.toUpperCase(),
                      'Cobros'.toUpperCase(),
                      'Capital cobrado'.toUpperCase(),
                      'Interes cobrado'.toUpperCase(),
                      'Gasto cierre'.toUpperCase(),
                      'Mora cobrada'.toUpperCase(),
                      'Total cobrado'.toUpperCase()
                      ],
            styles: {
              font: {bold: true},
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' },
                bgColor: { argb: 'FFFF00' }
              },
              border: {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
              }
            },
            columnOptions: [
              { key: 1, properties: { width: 40 } },
              { key: 2, properties: { width: 12 } },
              { key: 3, properties: { width: 12, numFmt : '$#,##0.00;[Red]-$#,##0.00'  } },
              { key: 4, properties: { width: 15, numFmt : '$#,##0.00;[Red]-$#,##0.00'  } },
              { key: 5, properties: { width: 14 } },
              { key: 6, properties: { width: 17, numFmt : '$#,##0.00;[Red]-$#,##0.00'  } },
              { key: 7, properties: { width: 17, numFmt : '$#,##0.00;[Red]-$#,##0.00'  } },
              { key: 8, properties: { width: 15, numFmt : '$#,##0.00;[Red]-$#,##0.00'  } },
              { key: 9, properties: { width: 15, numFmt : '$#,##0.00;[Red]-$#,##0.00'  } },
              { key: 10, properties: { width: 15, numFmt : '$#,##0.00;[Red]-$#,##0.00'  } },
              // { key: 11, properties: { width: 20 } },
              // { key: 12, properties: { width: 20 } },
              // { key: 13, properties: { width: 20 } },
              // { key: 14, properties: { width: 20 } },
              // { key: 15, properties: { width: 25 } }
            ]
          };

          const data: ExcelRows = {
            rows: []
          };

          if(conListaclientes){
          rows.forEach( row => {
            data.rows.push([
              row['0'],
              row['1'],
              row['2'],
              row['3'],
              row['4'],
              row['5'],
              row['6'],
              row['7'],
              row['8'],
              row['9'],
            ]);
          })
        }
          this.excelService.generateExcel(
            titulo,
             columns,
             data,
             {state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'A7', activeCell: 'A7'},
             this.rentabilidad
             ).then(
               () => this.exportando = false
               );

        }
      });
    }
  }

  navigate(item, tipo: number) {
    localStorage.setItem('rentabilidad_ruta_active', item.ID_P);
    this.router.navigate((tipo === 1) ? ['/cliente', item.ID_C] : ['/prestamo', item.ID_P]);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/reportes/retabilidad-ruta/retabilidad-ruta.component.ts